module.exports = __webpack_public_path__ + "static/media/location-icon-white.483809a9.svg";